import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { useEffect, useState } from "react";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { Button } from "primereact/button";
import { ColorMatriz } from "../../models/matriz/ColorMatriz";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";

export const ParametroMatriz = ({ generic, permss, toast, catalogo }) => {
    const omodel = new ColorMatriz();
    const defaultValues = generic.default(omodel.model);
    const [registers, setRegisters] = useState(null);
    const { control, formState: { errors }, handleSubmit, setError, getValues, reset, setValue } = useForm({ defaultValues, shouldTrim: true });
    const { table, setLoading, setTotalRecords, lazyParams, inAutocomplete, inDrop } = InputComponent({ registers, omodel, generic, errors, control, permss, id: getValues('id') });
    const [loadConfig, setLoadConfig] = useState(false);
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [dialogEmpresa, setDialogEmpresa] = useState(false);
    const [lista, setLista] = useState(null);
    const monitoreoService = new MonitoreoService();
    const [areasNegocioEmpresa, setAreasNegocioEmpresa] = useState([]);
    const [loadingAreas, setLoadingAreas] = useState(false);

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        let _lazyParams = lazyParams;
        monitoreoService.listado('matriz/configuracion/lista-color', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegisters(res.data.registros);
            setLoading(false);
        });
    }

    const onConfigure = (data) => {
        setLoadConfig(true);
        monitoreoService.nuevo(data, 'matriz/configuracion/parametro').then(res => {
            loadLazyData();
            setDialogEmpresa(false);
            setAreasNegocioEmpresa([]);
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setLoadConfig(false);
        });
    }

    const onPlantillaChange = (e) => {
        const plantillaSeleccionada = e.value;
        if (plantillaSeleccionada?.nemonico === 'RIESGO_CLIENTE') {
            const empresa = getValues('empresa');
            if (empresa) areasNegocio(empresa);
        } else {
            setValue('tipo_negocio', null);
            setAreasNegocioEmpresa([]);
        }
    };

    const searchEmpresa = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length) {
                setLista([...lista]);
            }
            else {
                monitoreoService.consultar(event.query.toLowerCase(), 'administracion/empresa-buscar/razon').then(data => {
                    setLista(data);
                });
            }
        });
    }

    const areasNegocio = (empresa, tipoNegocioId = null) => {
        setLoadingAreas(true);
        const empresaId = (empresa && typeof empresa === 'object') ? empresa.cat_id : empresa;
        monitoreoService.consultar(empresaId, 'administracion/empresa-areas')
            .then(res => {
                const lista = res.data;
                setAreasNegocioEmpresa(lista);
                if (tipoNegocioId != null) {
                    const match = lista.find(a => a.cat_id === tipoNegocioId);
                    if (match) setValue('tipo_negocio', match);
                } else {
                    setValue('tipo_negocio', null);
                }
            })
            .catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoadingAreas(false);
            });
    };

    const leftToolbarTemplate = () => {
        return (
            <Button label="Generar parámetros" icon="pi pi pi-bookmark" className="p-button-success mr-2" onClick={generar} />
        );
    }

    const generar = () => {
        setDialogEmpresa(true);
        reset(defaultValues);
        setLoadConfig(false)
    }

    return (
        <>
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={leftToolbarTemplate}></Toolbar>
                {table()}
            </Card>
            <Dialog visible={dialogEmpresa} header="Crear parámetros iniciales por empresa" modal className="p-fluid modal-ssize"
                onHide={() => { setDialogEmpresa(false); setAreasNegocioEmpresa(null); setValue('tipo_negocio', null); }} style={{ maxWidth: '400px' }} >
                <form onSubmit={handleSubmit(onConfigure)}>
                    <div className="formgrid grid">
                        {inAutocomplete('empresa', selectedEmpresa, setSelectedEmpresa, lista, searchEmpresa, {
                            lab: omodel.optionLabel, col: 12, noEsActividad: true, onSelect: (empresaSeleccionada) => {
                                const plantilla = getValues('plantilla');
                                if (plantilla?.nemonico === 'RIESGO_CLIENTE') {
                                    areasNegocio(empresaSeleccionada);
                                }
                            }
                        })}
                        {inDrop('plantilla', catalogo?.plantilla, { lab: omodel.optionLabel, chn: onPlantillaChange }, 12)}
                        {loadingAreas ? (
                            <div className="col-12 text-center">
                                <ProgressSpinner style={{ width: '30px', height: '30px', marginTop: '15px', marginBottom: '20px' }} strokeWidth="6" />
                            </div>
                        ) : (
                            areasNegocioEmpresa?.length > 0 &&
                            inDrop('tipo_negocio', areasNegocioEmpresa, { lab: omodel.optionLabel, col: 12 }, 12)
                        )}
                        <div className="field col">
                            <Button label="configurar" style={{ maxWidth: '120px', float: 'right' }} type="submit" icon="pi pi-check" className="p-button-warning" loading={loadConfig} title="Configurar" />
                        </div>
                    </div>
                </form>
            </Dialog>
        </>
    )
}
